import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

import { TextField, DropDownMenu, MenuItem } from 'material-ui';

import Btn from '../../../components/Btn';


import '../../../grid.css';

class ProjectAddress extends Component {
    static propTypes = {
        isOpen: PropTypes.bool.isRequired,
        isLocked: PropTypes.bool.isRequired,
        projectState: PropTypes.number.isRequired,
        projectName: PropTypes.string.isRequired,
        projectStreet: PropTypes.string.isRequired,
        projectStreet2: PropTypes.string.isRequired,
        projectCity: PropTypes.string.isRequired,
        projectCountry: PropTypes.string.isRequired,
        projectZip: PropTypes.string.isRequired,
        setProjectState: PropTypes.func.isRequired,
        setProjectName: PropTypes.func.isRequired,
        setProjectStreet: PropTypes.func.isRequired,
        setProjectStreet2: PropTypes.func.isRequired,
        setProjectIsOpen: PropTypes.func.isRequired,
        setProjectZip: PropTypes.func.isRequired,
        setProjectCountry: PropTypes.func.isRequired,
        setProjectCity: PropTypes.func.isRequired,
    };

    togglePAIsVisible() {
        const { setProjectIsOpen, isOpen } = this.props;
        setProjectIsOpen(!isOpen);
    }

    handleChange(value) {
        const { setProjectState } = this.props;
        setProjectState(value);
    }

    handleClientNameChange(value) {
        const { setProjectName } = this.props;
        setProjectName(value);
    }

    handleStreetChange(value) {
        const { setProjectStreet } = this.props;
        setProjectStreet(value);
    }
    handleStreetChange2(value) {
        const { setProjectStreet2 } = this.props;
        setProjectStreet2(value);
    }

    handleZipChange(value) {
        const { setProjectZip } = this.props;
        setProjectZip(value);
    }
    handleCityChange(value) {
        const { setProjectCity } = this.props;
        setProjectCity(value);
    }
    handleCountryChange(value) {
        const { setProjectCountry } = this.props;
        setProjectCountry(value);
    }

    render() {
        const {
            projectState,
            projectName,
            projectStreet,
            projectStreet2,
            isLocked,
            projectZip,
            isOpen,
            projectCity,
            projectCountry,
        } = this.props;


        return (
            <div>
                <Btn label="Project Address" onClick={(e, value) => this.togglePAIsVisible(value)} />
                {isOpen ? (
                    <div className="row">
                        <div className="col span-1-of-2">

                            <TextField
                                autoFocus
                                margin="dense"
                                defaultValue={projectName}
                                floatingLabelText="Project Name"
                                onChange={(e, value) => this.handleClientNameChange(value)}
                                disabled={isLocked}
                                fullWidth
                            />
                            <TextField
                                floatingLabelText="Project Street Address"
                                onChange={(e, value) => this.handleStreetChange(value)}
                                disabled={isLocked}
                                fullWidth
                                defaultValue={projectStreet}
                            />
                            <TextField
                                floatingLabelText="Suite/Apt Number"
                                onChange={(e, value) => this.handleStreetChange2(value)}
                                disabled={isLocked}
                                fullWidth
                                defaultValue={projectStreet2}
                            />

                        </div>
                        <div className="col span-1-of-2">
                            <TextField
                                floatingLabelText="Project City"
                                onChange={(e, value) => this.handleCityChange(value)}
                                disabled={isLocked}
                                fullWidth
                                defaultValue={projectCity}
                            />
                            <TextField
                                fullWidth
                                floatingLabelText="Zip"
                                onChange={(e, value) => this.handleZipChange(value)}
                                disabled={isLocked}
                                defaultValue={projectZip}
                            />
                            <DropDownMenu
                                fullWidth
                                label="State"
                                value={projectState}
                                onChange={(e, index, value) => this.handleChange(value)}
                                disabled={isLocked}
                            >
                                <MenuItem value={1} primaryText="California" />
                                <MenuItem value={5} primaryText="Florida" />
                                <MenuItem value={2} primaryText="Massachusetts" />
                                <MenuItem value={3} primaryText="New Jersey" />
                                <MenuItem value={4} primaryText="New York" />
                            </DropDownMenu>

                            <DropDownMenu
                                fullWidth
                                label="Country"
                                value={projectCountry}
                                onChange={(e, index, value) => this.handleCountryChange(value)}
                                disabled={isLocked}
                            >
                                <MenuItem value="USA" primaryText="United States of America" />
                                <MenuItem value="other" primaryText="Other" />
                            </DropDownMenu>
                        </div>
                    </div>)
                    : null }
            </div>
        );
    }
}

export default ProjectAddress;



// WEBPACK FOOTER //
// ./src/containers/Inputs/ProjectAddress/ProjectAddress.js